/***
*
*   MODAL SHELL
*   Estructura única para los modales propios de las vistas (los que no
*   pasan por ViewContext.modal): cabecera amarilla con icono redondo,
*   título y subtítulo, botón de cerrar, cuerpo con scroll y pie de acciones.
*
*   PROPS
*   icon:     nodo del icono de la cabecera (opcional)
*   title:    título
*   subtitle: bajada (opcional)
*   width:    ancho máximo en px (default 520)
*   onClose:  cierra el modal (también con clic fuera y Escape)
*   footer:   acciones; usar <FlatButton variant="cancel" | "primary">
*
**********/

import React, { useEffect } from 'react';

const IconClose = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export function ModalShell({ icon, title, subtitle, width = 520, onClose, footer, children }) {

  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      style={s.overlay}
      onClick={e => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div style={{ ...s.card, width }}>

        <div style={s.header}>
          <div style={s.headerLeft}>
            {icon && <div style={s.headerIcon}>{icon}</div>}
            <div style={{ minWidth: 0 }}>
              <div style={s.title}>{title}</div>
              {subtitle && <div style={s.subtitle}>{subtitle}</div>}
            </div>
          </div>
          <button onClick={onClose} style={s.close} aria-label="Cerrar" title="Cerrar">
            <IconClose />
          </button>
        </div>

        <div style={s.body}>{children}</div>

        {footer && <div style={s.footer}>{footer}</div>}

      </div>
    </div>
  );
}

const s = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 1000,
    background: 'rgba(0, 0, 0, 0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 20,
  },
  card: {
    background: '#fff', borderRadius: 14,
    maxWidth: '94vw', maxHeight: 'calc(100vh - 40px)',
    display: 'flex', flexDirection: 'column',
    boxShadow: '0 24px 64px rgba(0, 0, 0, 0.28)',
    overflow: 'hidden',
  },
  header: {
    background: '#FFB800',
    padding: '14px 24px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 12, flexShrink: 0,
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 },
  headerIcon: {
    width: 38, height: 38, borderRadius: '50%',
    background: 'rgba(0, 0, 0, 0.10)', color: '#3d2f00',
    display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
  },
  title: {
    fontSize: 15, fontWeight: 700, color: '#111827',
    letterSpacing: '0.01em',
    overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
  },
  subtitle: {
    fontSize: 11.5, fontWeight: 600, color: '#3d2f00', opacity: 0.8,
    marginTop: 2, lineHeight: 1.3,
  },
  close: {
    background: 'rgba(0, 0, 0, 0.12)', border: 'none', cursor: 'pointer',
    width: 28, height: 28, borderRadius: '50%', padding: 0, flexShrink: 0,
    color: '#111827', display: 'flex', alignItems: 'center', justifyContent: 'center',
  },
  body: {
    flex: 1, minHeight: 0, overflowY: 'auto',
    padding: '20px 24px',
    display: 'flex', flexDirection: 'column', gap: 12,
  },
  footer: {
    flexShrink: 0,
    borderTop: '1px solid #E2E8F0',
    padding: '14px 24px',
    display: 'flex', justifyContent: 'center', gap: 8, alignItems: 'center',
    background: '#fff',
  },
};
